module.exports = __webpack_public_path__ + "static/media/16.730bf656.png";